import { ModelNamedProperty } from "./named-property";
import { browseFieldPathToFilterFieldPath } from "./utils";

export class DefaultNamedProperty extends ModelNamedProperty {
	pathToFilterPath(): string {
		return browseFieldPathToFilterFieldPath(this.path);
	}
}